module.exports = __webpack_public_path__ + "img/编组 4@2x.b38276ae.png";